import React from 'react'
import Tab from '@mui/material/Tab'
import Tabs from '@mui/material/Tabs'
import { PageTitle } from 'uiComponents/typography'
import MembershipsTable from './membershipsTable/membershipsTable'
import MembershipDetailsPanel from './membershipDetailsPanel/membershipDetailsPanel'
import { getHashRoute, getHashParam, removeHash, setHash } from 'utils/hash'
import { isUserReseller } from 'auth/selectors'
import { useSelector } from 'react-redux'
import { ProductsList } from './productsList'
import { useNavigation } from 'hocs'
import { useTranslation } from 'translations'

const TAB_QUERY_VALUES = ['overview', 'pricing'] as const
type TabQueryValue = typeof TAB_QUERY_VALUES[number]

const MembershipsPage = () => {
    const { t } = useTranslation()
    const navigation = useNavigation()
    const activeTab = navigation.query().tab === 'pricing' ? 1 : 0
    const selectedMembershipUuid = getHashParam('membershipUuid')
    const showMembershipDetailsPanel = getHashRoute() === 'membership_details' && selectedMembershipUuid
    const isReseller = useSelector(isUserReseller)

    const handleTabChange = (newValue: number) => {
        const tabValue: TabQueryValue = TAB_QUERY_VALUES[newValue] ?? 'overview'
        navigation.addQueryWithReplace({ tab: tabValue === 'overview' ? null : tabValue })
    }

    const handleSelectMembership = (membershipUuid: string) => {
        setHash('membership_details', { membershipUuid })
    }

    if (isReseller) {
        return null
    }

    return (
        <div>
            <PageTitle>{t('memberships.title')}</PageTitle>
            <Tabs value={activeTab} onChange={(_, newValue) => handleTabChange(newValue)} sx={{ mb: 4, pl: 0 }}>
                <Tab label={t('memberships.tabs.overview')} />
                <Tab label={t('memberships.tabs.pricing')} />
            </Tabs>
            {activeTab === 0 && (
                <>
                    <MembershipsTable onSelectMembership={handleSelectMembership} />
                    {showMembershipDetailsPanel && (
                        <MembershipDetailsPanel membershipUuid={selectedMembershipUuid} onClose={removeHash} />
                    )}
                </>
            )}
            {activeTab === 1 && (
                <ProductsList />
            )}
        </div>
    )
}

export default MembershipsPage
